@if (text === 'yes') {
  <div class="d-flex flex-column">
    @if (!item.socials.twitter?.username && !item.socials.instagram?.username && !item.socials.facebook?.username && !item.socials.linkedin?.username) {
      <p>
        No socials found.
      </p>
    }
    <div [hidden]="!item.socials.twitter?.username">
      @if (side === 'left') {
        <i class="fa fa-twitter"></i>
      }
      <a [href]="'https://x.com/' + item.socials.twitter?.username" target="_blank" class="text-break">
        <!-- <i class="fa fa-circle fa-pulse text-danger" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Live streaming" *ngIf="item.socials.twitter?.app_stream"></i> -->
        {{item.socials.twitter?.username}} @if (side === 'right') {
        <i class="fa fa-twitter"></i>
      }
    </a>
  </div>
  <div [hidden]="!item.socials.instagram?.username">
    @if (side === 'left') {
      <i class="fa fa-instagram"></i>
    }
    <a [href]="'https://instagram.com/' + item.socials.instagram?.username" target="_blank" class="text-break">
      {{item.socials.instagram?.username}} @if (side === 'right') {
      <i class="fa fa-instagram"></i>
    }
  </a>
</div>
<div [hidden]="!item.socials.facebook?.username">
  @if (side === 'left') {
    <i class="fa fa-facebook-official"></i>
  }
  <a [href]="'https://facebook.com/' + item.socials.facebook?.username" target="_blank" class="text-break">
    {{item.socials.facebook?.username?.substring(0, 25)}} @if (side === 'right') {
    <i class="fa fa-facebook-official"></i>
  }
</a>
</div>
<div [hidden]="!item.socials.linkedin?.username">
  @if (side === 'left') {
    <i class="fa fa-linkedin-square"></i>
  }
  <a [href]="'https://linkedin.com/' + (item.firstName ? 'in/' : 'company/') + item.socials.linkedin?.username" target="_blank" class="text-break">
    {{item.socials.linkedin?.username?.substring(0, 25)}} @if (side === 'right') {
    <i class="fa fa-linkedin-square"></i>
  }
</a>
</div>
<div [hidden]="!item.website">
  @if (side === 'left') {
    <i class="fa fa-home"></i>
  }
  <a [href]="item.website" target="_blank" class="text-break">
    {{item.website?.split('//')?.pop()}} @if (side === 'right') {
    <i class="fa fa-home"></i>
  }
</a>
</div>
</div>
}
@if (text === 'no') {
  <div>
    @if (item.socials?.twitter?.username) {
      <a class="ms-2" [href]="'https://x.com/' + item.socials?.twitter?.username" target="_blank">
        <i class="fa fa-twitter"></i>
        <!-- <i class="fa fa-circle fa-pulse text-danger" data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Live streaming" *ngIf="item.socials?.twitter?.app_stream"></i> -->
      </a>
    }
    @if (item.socials?.instagram?.username) {
      <a class="ms-2" [href]="'https://instagram.com/' + item.socials?.instagram?.username" target="_blank">
        <i class="fa fa-instagram"></i>
      </a>
    }
    @if (item.socials?.facebook?.username) {
      <a class="ms-2" [href]="'https://facebook.com/' + item.socials?.facebook?.username" target="_blank">
        <i class="fa fa-facebook-official"></i>
      </a>
    }
    @if (item.socials?.linkedin?.username) {
      <a class="ms-2" [href]="'https://linkedin.com/' + (item.firstName ? 'in/' : 'company/') + item.socials?.linkedin?.username" target="_blank">
        <i class="fa fa-linkedin-square"></i>
      </a>
    }
    @if (item.website) {
      <a class="ms-2" [href]="item.website" target="_blank">
        <i class="fa fa-home"></i>
      </a>
    }
  </div>
}